<template>
  <CRow>
    <CCol col="4" v-if="found">
      <CCard>
        <loader v-show="loadingDetail" />
        <CCardHeader>
          <CIcon name="cil-lan" /> &nbsp; <strong>Outlet Detail</strong>
          <div class="card-header-actions">
            <CLink href="#" @click="doBack">
              <CIcon name="cil-arrow-circle-left" size="lg" />
            </CLink>
          </div>
        </CCardHeader>
        <CCardBody>
          <div class="c-profile">
            <img
              v-show="data.avatar_url == ''"
              src="/img/logo2.png"
              class="c-profile-img"
            />
            <img
              v-show="data.avatar_url != ''"
              :src="data.avatar_url"
              class="c-profile-img"
            />
          </div>
          <div class="c-profile">
            <strong>{{ data.name }}</strong
            ><br />
            <strong>{{ data.code }}</strong>
            <br />
            <span
              v-for="(c, k) in data.categories"
              :key="k"
              class="badge badge-success"
              style="margin-right: 5px"
              >{{ c.label }}
            </span>
          </div>
          <table class="table-profile">
            <tbody>
              <tr>
                <td><strong>Alamat</strong></td>
                <td>:</td>
                <td>
                  {{ data.detail_address }}<br v-show="data.detail_address" />
                  <span v-if="data.address">
                    <span v-if="data.address.sub_district">
                      {{ data.address.sub_district }},
                    </span>
                    <span v-if="data.address.district">
                      {{ data.address.district }},
                    </span>
                    <span v-if="data.address.city">
                      {{ data.address.city }},
                    </span>
                    <span v-if="data.address.province">
                      {{ data.address.province }},
                    </span>
                    {{ data.address.post_code }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><strong>Gmap</strong></td>
                <td>:</td>
                <td>
                  <a
                    class="link"
                    :href="`http://maps.google.com/maps?q=${data.lat},${data.lng}`"
                    target="_blank"
                  >
                    View GMap<i class="cil cil-external-link"></i
                  ></a>
                </td>
              </tr>
              <tr>
                <td><strong>Web ID</strong></td>
                <td>:</td>
                <td>{{ data.slug }}</td>
              </tr>
              <tr>
                <td><strong>Email</strong></td>
                <td>:</td>
                <td>{{ data.email }}</td>
              </tr>
              <tr>
                <td><strong>Terdaftar Sejak</strong></td>
                <td>:</td>
                <td>{{ data.email }}</td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol lg="4">
      <CCard>
        <loader v-show="loadingDashboard" />
        <CCardBody>
          <CRow>
            <CCol sm="6">
              <CCallout color="info">
                <small class="text-muted">Total Produk</small><br />
                <strong class="h4">{{ dashboard.product_count }}</strong>
              </CCallout>
            </CCol>
            <CCol sm="6">
              <CCallout color="danger">
                <small class="text-muted">Total Transaksi</small><br />
                <strong class="h4">{{ dashboard.transaction_count }}</strong>
              </CCallout>
            </CCol>
          </CRow>
          <h5>Produk Terlaris</h5>
          <hr class="mt-0" />
          <div
            class="progress-group mb-4"
            v-for="(v, k) in dashboard.best_seller"
            :key="k"
          >
            <div class="progress-group-prepend">
              <span class="progress-group-text"> {{ v.name }} </span>
            </div>
            <div class="progress-group-bars">
              <CProgress
                class="progress-sm pointer"
                :value="v.qty"
                color="info"
                v-c-tooltip.hover.click="v.variant + ' qty(' + v.qty + ')'"
              />
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol lg="4">
      <CCard>
        <CCardHeader>
          <CIcon name="cil-paperclip" /> &nbsp; <strong>Attachment</strong>
        </CCardHeader>
        <CCardBody>
          <div
            style="
              width: 208px;
              overflow: hidden;
              border: 1px solid #ababab;
              padding: 4px;
            "
            v-if="
              attachment.card_id &&
              attachment.card_id.uri &&
              attachment.card_id.uri != ''
            "
          >
            Foto ID Card <br />
            <img :src="attachment.card_id.url" width="200px" />
          </div>
          <CButton
            variant="outline"
            name="save"
            color="success"
            style="margin-top: 10px"
            @click="openUplIDCard = true"
            >Upload ID Card</CButton
          >
          <div
            style="
              width: 208px;
              overflow: hidden;
              border: 1px solid #ababab;
              padding: 4px;
              margin-top: 15px;
            "
            v-if="
              attachment.card_id_selfie &&
              attachment.card_id_selfie.uri &&
              attachment.card_id_selfie.uri != ''
            "
          >
            Foto ID Card + Selfie<br />
            <img :src="attachment.card_id_selfie.url" width="200px" />
          </div>
          <CButton
            variant="outline"
            name="save"
            color="success"
            style="margin-top: 10px"
            @click="openUplIDCardSelfie = true"
            >Upload ID Card + Selfie</CButton
          >
          <div
            style="
              width: 208px;
              overflow: hidden;
              border: 1px solid #ababab;
              padding: 4px;
              margin-top: 25px;
            "
            v-if="
              attachment.outlet &&
              attachment.outlet.uri &&
              attachment.outlet.uri != ''
            "
          >
            Foto Kios <br />
            <img :src="attachment.outlet.url" width="200px" />
          </div>
          <CButton
            variant="outline"
            name="save"
            color="success"
            style="margin-top: 10px"
            @click="openUplPicOutlet = true"
            >Upload Foto Dengan Kios</CButton
          >
          <div
            style="
              width: 208px;
              overflow: hidden;
              border: 1px solid #ababab;
              padding: 4px;
              margin-top: 15px;
            "
            v-if="
              attachment.mou && attachment.mou.uri && attachment.mou.uri != ''
            "
          >
            Foto Agreement <br />
            <img :src="attachment.mou.url" width="200px" />
          </div>
          <CButton
            variant="outline"
            name="save"
            color="success"
            style="margin-top: 10px"
            @click="openUplMou = true"
            >Upload MOU</CButton
          >
        </CCardBody>
        <CCardFooter>
          <btn-save-update
            @back="doBack"
            @save="doSaveAttch"
            @update="doUpdateAttch"
            :data="attachment"
          />
        </CCardFooter>
      </CCard>
    </CCol>
    <CCol v-if="!found">
      <CCard>
        <CCardBody>
          Silahkan pilih outlet terlebihdahulu di menu outlet list
        </CCardBody>
      </CCard>
    </CCol>
    <modal-image-uploader
      @success="successUploadIDCard"
      @cancel="cancelUpload"
      :show="openUplIDCard"
      title="Upload ID Card"
    />
    <modal-image-uploader
      @cancel="cancelUpload"
      @success="successUploadIDCardSelfie"
      :show="openUplIDCardSelfie"
      title="Upload ID Card + Selfie"
    />
    <modal-image-uploader
      @cancel="cancelUpload"
      @success="successUploadPicOutlet"
      :show="openUplPicOutlet"
      title="Upload Kios"
    />
    <modal-image-uploader
      @cancel="cancelUpload"
      @success="successUploadMou"
      :show="openUplMou"
      title="Upload Agreement"
    />
  </CRow>
</template>
<script>
import { getOutletCode, showErrorMessage } from "../../lib/helpers";
import { HTTPAUTH } from "../../lib/httplib";
import Loader from "../../components/Loader";
import ModalImageUploader from "../../components/ModalImageUploader.vue";
import BtnSaveUpdate from "../../components/BtnSaveUpdate.vue";
export default {
  components: {
    Loader,
    ModalImageUploader,
    BtnSaveUpdate,
  },
  data() {
    return {
      data: {},
      dashboard: {},
      found: true,
      code: "",
      loadingDetail: true,
      loadingDashboard: true,
      openUplIDCard: false,
      openUplIDCardSelfie: false,
      openUplPicOutlet: false,
      openUplMou: false,
      attachment: {
        mou: {},
        card_id: {},
        card_id_selfie: {},
        outlet: {},
      },
    };
  },
  created() {
    const params = this.$route.params;
    if (params && params.code) {
      var code = params.code;
      if (code == "-") {
        code = getOutletCode();
      }
      this.get(code);
      this.getDashboard(code);
    }
  },
  methods: {
    get(id) {
      this.loadingDetail = true;
      HTTPAUTH.get("/api/admin/outlet/" + id)
        .then((res) => {
          this.data = res.data.data;
          this.found = true;
          this.loadingDetail = false;
          this.getAttachment(this.data.id);
        })
        .catch((eres) => {
          this.found = false;
          this.loadingDetail = false;
        });
    },
    getDashboard(id) {
      this.loadingDashboard = true;
      HTTPAUTH.get("/api/admin/outlet/" + id + "/dashboard")
        .then((res) => {
          this.dashboard = res.data.data;
          this.found = true;
          this.loadingDashboard = false;
        })
        .catch((eres) => {
          this.found = false;
          this.loadingDashboard = false;
        });
    },
    getAttachment(id) {
      HTTPAUTH.get("/api/admin/outlet/attachment/" + id)
        .then((res) => {
          this.attachment = res.data.data;
        })
        .catch((eres) => {
        });
    },
    doBack() {
      this.$router.push({ path: "/outlet" });
    },
    cancelUpload() {
      this.openUplIDCard = false;
      this.openUplIDCardSelfie = false;
      this.openUplPicOutlet = false;
      this.openUplMou = false;
    },
    successUploadIDCard(data) {
      this.openUplIDCard = false;
      this.attachment.card_id = data;
    },
    successUploadIDCardSelfie(data) {
      this.openUplIDCardSelfie = false;
      this.attachment.card_id_selfie = data;
    },
    successUploadPicOutlet(data) {
      this.openUplPicOutlet = false;
      this.attachment.outlet = data;
    },
    successUploadMou(data) {
      this.openUplMou = false;
      this.attachment.mou = data;
    },
    doSaveAttch() {
      HTTPAUTH.post(
        "/api/admin/outlet/attachment/" + this.data.id,
        this.attachment
      )
        .then((res) => {
          this.$toasted.success("Berhasil Update Attachment").goAway();
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    doUpdateAttch() {
      this.doSaveAttch();
    },
  },
};
</script>